var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleNotSupportEpg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9089 39.0909H69.4544V28.7273C69.4544 17.3273 60.1271 8 48.7271 8C37.3271 8 27.9998 17.3273 27.9998 28.7273V39.0909H24.5453C18.6725 39.0909 14.1816 43.5818 14.1816 49.4545V73.6364C14.1816 79.5091 18.6725 84 24.5453 84H72.9089C78.7816 84 83.2725 79.5091 83.2725 73.6364V49.4545C83.2725 43.5818 78.7816 39.0909 72.9089 39.0909ZM34.9073 28.7267C34.9073 21.1267 41.1255 14.9085 48.7255 14.9085C56.3255 14.9085 62.5437 21.1267 62.5437 28.7267V39.0903H34.9073V28.7267ZM72.9125 77.0909C74.9853 77.0909 76.3671 75.7091 76.3671 73.6364V49.4545C76.3671 47.3818 74.9853 46 72.9125 46H24.5489C22.4762 46 21.0944 47.3818 21.0944 49.4545V73.6364C21.0944 75.7091 22.4762 77.0909 24.5489 77.0909H72.9125Z",
    fill: "#0661FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleNotSupportEpg);
export default __webpack_public_path__ + "static/media/role-not-support-epg.6952443e0379fa4096ebde74e6f82e82.svg";
export { ForwardRef as ReactComponent };